import { render, staticRenderFns } from "./AITodoComponent.vue?vue&type=template&id=140a3132&scoped=true"
import script from "./AITodoComponent.vue?vue&type=script&lang=js"
export * from "./AITodoComponent.vue?vue&type=script&lang=js"
import style0 from "./AITodoComponent.vue?vue&type=style&index=0&id=140a3132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a3132",
  null
  
)

export default component.exports